import useApi from '../utils/axios-pettitions';

export const useApiAnalyzer = () => {
  const { runApi } = useApi();

  const getTrace = (IdAnalyzer, Page) => {
    return runApi('Analyzers', 'GET', {IdAnalyzer, Page}, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        return res.data;
      }
    });
  };

  return { getTrace };
};